import { useHistory, useLocation } from "react-router";
import IconBar from "../../Partials/IconBar";
import TabPages from "../../Partials/TabPages";
import React, { useEffect, useState } from "react";
import ReferenceList from "../../Tests/ReferenceList";
import {useAuth} from "../../../context/AuthContext";

const ResourceDashboard = () => {
  const history = useHistory();

  const { user } = useAuth()

  const activateTests = () => {
    history.push("/testdashboard", { user: user });
  };

  const tabHeadings = ["TESTS", "RESOURCES"];
  const tabFunctions = [activateTests, () => {}];

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: windowWidth >= 800 ? "50%" : "90%",
        }}
      >
        <div style={{ padding: "10px 0" }}>
          {/*tab container*/}
          <div
            style={{
              position: "sticky",
              top: "0",
              backgroundColor: "#00112e",
              zIndex: 999,
            }}
          >
            {/*icon bar*/}
            <div>
              <IconBar location={"dashboard"} user={user} />
            </div>
            {/*tab headings*/}
            <div style={{ width: "100%" }}>
              <TabPages
                tabHeadings={tabHeadings}
                tabFunctions={tabFunctions}
                tabActive={1}
              ></TabPages>
            </div>
          </div>
          <div style={{ backgroundColor: "#DFDFDF" }}></div>
          <div style={{ zIndex: -999 }}>
            <ReferenceList user={user} />
          </div>
        </div>
      </div>
    </>
  );
};

export default ResourceDashboard;
